/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-control.ng-touched.ng-invalid[_ngcontent-%COMP%]{border-bottom:2px solid red}.text-wrap[_ngcontent-%COMP%]{white-space:break-spaces;max-width:300px;word-wrap:break-word}.required-asterisk[_ngcontent-%COMP%]{color:red}"];
export { styles as styles };
